'use strict';

import 'angular';

import './style.css';

import containerDirective from './container';
import expansionDirective from './expansion';

var MODULE_NAME = 'daupler.incidents.components.expansions';

var app = angular.module(MODULE_NAME, []);
app.directive('expansionContainer', containerDirective);
app.directive('expansion', expansionDirective(false));
app.directive('antiExpansion', expansionDirective(true));

export default MODULE_NAME;
